module.exports = __webpack_public_path__ + "r-v3/img/text.12fa995b.svg";